var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Attendere...")]),_c('QsRemoteAccess',{attrs:{"dest":_vm.$route.params.dest}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }